import { User } from 'oidc-client-ts';
import { isEmailVerified } from 'src/shared/utils/user';
import container from 'src/config/inversify-config';
import { UsersApiService } from 'src/api/identity/users-api';

export async function checkUserEmailConfirmed(user: User | null | undefined): Promise<boolean> {
  if (!user) return false;
  if (isEmailVerified(user)) return true;

  const usersApi = container.get<UsersApiService>(UsersApiService);
  try {
    return await usersApi.hasEmailConfirmed({
      userId: user.profile?.sub,
      userEmail: user.profile?.email
    });
  } catch {
    return false;
  }
}
